
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Select from '../../Component/Select';
import { PLATFORM } from '../../Hook/platform';

function LocationSelect({update}: any) {
  const intl = useIntl();
  const [continent, setContinent] = useState("all");
  const list = [{id: "all", value: intl.formatMessage({id: "profile__display_all"})},...Object.keys(PLATFORM.continent).map(cont => ({id: cont, value: intl.formatMessage({ id: "continent__" + cont })}))];
  return (
    <div className='flex gap-4 lg:gap-8 [&>*>*]:!text-white lg:[&>*]:flex-1 lg:h-[69px] mt-auto lg:justify-center w-full'>
      <Select onChange={setContinent} options={list} />
      <CountrySelect continent={continent} update={update}/>
    </div>
  )
}

function CountrySelect({continent, update}: any) {
  const intl = useIntl();
  const [country, setCountry] = useState<undefined|string>(-1 as any)

  useEffect(() => {
    setCountry(undefined);
    setTimeout(() => setCountry(-1 as any), 10);
  }, [continent])

  useEffect(() => {
    if(country) update(continent, country);
  }, [country, continent])

  if(!country) return <div className='relative w-full min-w-[200px] h-10'></div>;
  let memo:any[] = [];
  if(continent === "all"){
    memo = [{ id: -1, value: intl.formatMessage({id: "profile__display_all"}) }];
  }else{
    memo = [{ id: -1, value: intl.formatMessage({id: "profile__display_all"}) }, ...PLATFORM.continent[continent]]?.map((count:any, i) => ({id: count.id, value: count.name ?? count.value}));
  }
  return <Select onChange={setCountry} options={memo} />
}

export default LocationSelect